import React, { useState,useEffect } from 'react';
import {Box,Typography,Button} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import {IconButton} from "@mui/material"
import {useSelector, useDispatch} from 'react-redux';
import {styled, useTheme} from '@mui/material/styles'
import { Alarm, ArrowCircleRightOutlined, ArrowDropDownOutlined, CalendarTodayOutlined, CopyAllRounded, FileOpenTwoTone, FormatAlignCenter, NumbersTwoTone, QuizOutlined, Remove } from '@mui/icons-material';
import { FileOpen, TitleRounded } from '@mui/icons-material';
import MultiInput from './MultiInput';
import axios from 'axios';
import EditorText from './EditorText';

const ContainerBox = styled(Box, {
})(({ theme}) => ({
    transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 7,
    backgroundColor: '#000000'
},
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 5
}
})
);

const SendAcceptDialog = ({visible,setVisible,data,setOpen,setMessage,setNewData,candidate,isAccepted,title,description,setDescription,setTitle})=>{

const theme = useTheme()
const user = useSelector(state => state?.auth.user);
const job = useSelector(state => state?.job.job);
const participants = useSelector(state => state?.setting.candidates);
const size_sm = useMediaQuery(theme.breakpoints.up('sm'));
const dispatch = useDispatch()
const [showModal, setShowModal] = useState(false);
const [accepting, setAccepting] = useState(false);

const onClose = () => {
	setVisible(false);
};

async function handleSend(){
try {

    setAccepting(true)

    const send_data = {
       email:candidate?.user?.email,
       title:title,
       description:description,
       id:job?.id,
       isAccepted:isAccepted ? "accepted" : "rejected"
    }

    console.log(send_data)

    const sendSelect = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}send-selection`,send_data,{
        headers:{
            "Content-Type":"application/json",
            "Authorization":`Bear ${user?.accessToken}`
        }
    }).catch(err=>{
        setMessage("Error while sending, please try later")
        setOpen(true)
        setAccepting(false)
        console.log(err)
    })

    if (sendSelect?.status == 200 && sendSelect?.data.success) {
        
        const newData = job?.applicants?.filter(item=>item?.email !== candidate?.user?.email)
        const cand = job?.applicants?.filter(item=>item?.email === candidate?.user?.email)

        const data = {
            ...cand,
            status:isAccepted ? "accepted" : "rejected"
        }

        const allData = [...newData,data]
        setNewData(allData)

        await dispatch(add_job(allData))

        // const filterData = job?.applicants?.filter(item=>item?.status === "accepted")
        
        dispatch(add_candidates([...participants,{
            last_name:candidate?.user?.last_name,
            first_name:candidate?.user?.first_name,
            email:candidate?.user?.email
        }]))

        setMessage(sendSelect?.data.message)
        setOpen(true)
        setAccepting(false)
        setVisible(false)
        
    } else {
        setMessage(sendSelect?.data.message)
        setOpen(true)
        setAccepting(false)
        
    }

    console.log(sendSelect?.data)
} catch (error) {
    console.log(error)
}
}


return(    
	<Dialog open={visible} onClose={onClose} sx={{borderRadius:10,justifyContent:"center",textAlign:"left"}}>
		<DialogTitle sx={{background:theme.palette.background.default}}> 
			<Box width="90%" display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center">
				<IconButton sx={{marginTop:3}}>
					<FileOpen fontSize='small'/>
				</IconButton>					
				<Typography mr={2} mt={4} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
					candidate selection
				</Typography>		
			</Box>
		</DialogTitle>
		<DialogContent m={theme.spacing(1)} sx={{minWidth:{xs:300,md:500},justifyContent:"center",textAlign:"left",background:theme.palette.background.default}}>
			<ContainerBox width="100%">
                <Box justifyContent="flex-start" alignItems="flex-start" width="100%" p={1}>
                    <MultiInput
                        label="Email title *"
                        input={title}
                        isPass={false}
                        setInput={setTitle}
                    >
                        <FormatAlignCenter/>
                    </MultiInput> 
                    <Box width="100%">
                        <EditorText
                            data={description}
                            setData={setDescription}
                            width="95%"
                            label="Content"
                            isRequired={true}
                        />
                    </Box>
                    <Button onClick={async(e)=>{
                        e?.preventDefault()
                        await handleSend()
                    }} disabled={accepting} sx={{background:"#ff0",color:"#000",mt:1,height:35,fontFamily:"dinofans",fontSize:12}} variant="outlined">
                        {
                            accepting ? <CircularProgress sx={{color:"#000"}} size={15}/> : (isAccepted && !accepting) ? "Accept" : "Reject"
                        }
                    </Button>
                </Box>		
			</ContainerBox>
        </DialogContent>
	</Dialog>
	)
}

export default SendAcceptDialog